export default __webpack_public_path__ + "static/about2-060b2801a79b73e33165dce0c8f943ec.jpg";